import { type ImageByDPR } from './getImage';

const getSrcSet = (input: ImageByDPR[]): string => {
  if (!Array.isArray(input) || !input?.length) {
    return '';
  }

  return input
    .filter(({ image }) => !!image.images.fallback?.src)
    .map(({ image, dpr }) => `${image.images.fallback?.src} ${dpr}x`)
    .join(', ');
};

export default getSrcSet;
